import {rpc} from './session';

export async function getNews(meta = {}) {
    return await rpc.request('com.rnis.portal.action.news', {}, {meta});
}

export async function getNewsItem(uuid) {
    return await rpc.request('com.rnis.portal.action.news.get', {uuid});
}

export async function getFaq(meta = {}) {
    return await rpc.request('com.rnis.portal.action.faq', {}, {meta});
}

export async function getPage(key) {
    return await rpc.request('com.rnis.portal.action.page.get', {key});
}

export async function sendFeedback(data) {
    return await rpc.request('com.rnis.portal.action.feedback.send', data);
}

export async function getCaptcha() {
    return await rpc.request('com.rnis.portal.action.captcha.get');
}

export async function checkRegisterRequestCreate(data) {
    return await rpc.request('com.rnis.portal.action.register_request.create.check', data);
}

export async function createRegisterRequest(data) {
    return await rpc.request('com.rnis.portal.action.register_request.create', data);
}

export async function getRegisterRequest(uuid) {
    return await rpc.request('com.rnis.portal.action.register_request.get', {uuid});
}

export async function updateRegisterRequest(data) {
    return await rpc.request('com.rnis.portal.action.register_request.update', data);
}

export async function loginRegisterRequest(data) {
    return await rpc.request('com.rnis.portal.action.login', data);
}

export async function getTags() {
    return await rpc.request('com.rnis.portal.action.news.tags');
}


// WEBPACK FOOTER //
// ./src/helpers/api/portal.js